module.exports = __webpack_public_path__ + "static/media/coresiteWeb.9602e690.jpg";